import { useMemo } from 'react';
import { CatStatusIndicator } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import { SHOW_REFERENCE_ID } from 'components/notifications/utils/constants';
import { Notification } from 'services/notifications/types';
import styles from '../../notifications.module.scss';
import cx from 'classnames';
import StatusIndicatorIcon from '@cat-ecom/pcc-components/src/components/StatusIndicatorIcon';

export interface NotificationCardContentProps {
  notification: Notification;
  dcnListLength: number;
  isIAUser: boolean;
}

export const NotificationCardContent = ({
  notification,
  dcnListLength,
  isIAUser
}: NotificationCardContentProps) => {
  const t = useTranslations();
  const {
    dcn,
    orderStatus,
    orderNumber,
    formattedTotalOrderAmount,
    formattedDate,
    formattedTime,
    currency,
    referenceId,
    poNumber,
    isRead
  } = notification;
  const dcnToDisplay = dcnListLength === 1 || isIAUser ? null : dcn;
  const formattedDcn = dcnToDisplay?.split('-').join(' - ');

  const showAmount = useMemo(() => {
    return ['W', 'NEW', 'EXP', 'E'].includes(orderStatus);
  }, [orderStatus]);

  const showOrderIdentificator =
    !!orderNumber && SHOW_REFERENCE_ID.includes(orderStatus);

  return (
    <div className={styles['notification-card__content-container']}>
      {formattedTotalOrderAmount && showAmount && (
        <span
          className={styles['notification-card__text-amount']}
          data-testid="order-amount"
        >
          {formattedTotalOrderAmount} {currency}
        </span>
      )}
      {showOrderIdentificator ? (
        <div className={styles['notification-card__text-amount']}>
          <div
            className={`d-inline-block me-1`}
            data-testid="header-notification-reference-title"
          >
            {t('REFERENCE_ID')}
          </div>
          <span className="fw-normal">
            {orderStatus === 'OP' ? referenceId : orderNumber}
          </span>
        </div>
      ) : null}
      {poNumber ? (
        <div data-testid="purchase-Order-number">
          <p
            className={cx(
              styles['notification-card__content-poNumber'],
              'mb-0'
            )}
          >
            {`${t('PENDING_QUOTE7')}: ${poNumber}`}
          </p>
        </div>
      ) : null}
      {!isRead && (
        <CatStatusIndicator
          type="bare"
          className={`position-absolute ${styles['notification-card__content-status-indicator']}`}
          data-testid="not-read-status-indicator"
        >
          <StatusIndicatorIcon />
        </CatStatusIndicator>
      )}
      {dcnToDisplay ? (
        <div className={styles['notification-card__content-dcn']}>
          {formattedDcn}
        </div>
      ) : null}
      <div className={styles['notification-card__content-date']}>
        {formattedDate} &bull; {formattedTime}
      </div>
    </div>
  );
};
